import type { BadgeProps } from "@/components/ui/badge";
import type { IntegrationStatus, OnboardingStatus } from "@/types";

export type KYBStatus =
	| "draft"
	| "in-progress"
	| "submitted"
	| "under_review"
	| "approved"
	| "rejected";

export function getIntegrationBadgeVariant(
	status: IntegrationStatus,
): BadgeProps["variant"] {
	switch (status) {
		case "Live":
			return "success";
		case "Ready to Go Live":
			return "info";
		case "Testing":
			return "warning";
		case "Integrating":
			return "secondary";
		case "On-Hold":
			return "warning";
		default:
			return "secondary";
	}
}

export function getOnboardingBadgeVariant(
	status: OnboardingStatus,
): BadgeProps["variant"] {
	switch (status) {
		case "Onboarded":
			return "success";
		case "Onboarding in Progress":
			return "warning";
		default:
			return "secondary";
	}
}

export function getKybBadgeVariant(status: string): BadgeProps["variant"] {
	switch (status as KYBStatus) {
		case "draft":
			return "neutral";
		case "in-progress":
			return "warning";
		case "submitted":
			return "info";
		case "under_review":
			return "info";
		case "approved":
			return "success";
		case "rejected":
			return "destructive";
		default:
			return "neutral";
	}
}

export function getKybStatusLabel(status: string): string {
	switch (status as KYBStatus) {
		case "draft":
			return "Draft";
		case "in-progress":
			return "In Progress";
		case "submitted":
			return "Submitted";
		case "under_review":
			return "Under Review";
		case "approved":
			return "Approved";
		case "rejected":
			return "Rejected";
		default:
			return status;
	}
}
